(function() { window.GUID_b36c5475_e2b0_497e_b680_f21c089d7939 = { getGuid: function() { return "b36c5475-e2b0-497e-b680-f21c089d7939"; } }; })();
var CS;
(function (CS) {
    var Events;
    (function (Events) {
        function Trigger(eventType, extraParameters) {
            CS.DOM.$body.trigger(eventType, extraParameters);
        }
        Events.Trigger = Trigger;
        function $On(eventType, selectorOrCallBack, callback, dontAutoOffOnDispose) {
            if (typeof callback === "boolean") { //firstOverload
                dontAutoOffOnDispose = callback;
                if (dontAutoOffOnDispose)
                    CS.DOM.$body.offonwithoutautooff(eventType, selectorOrCallBack);
                else
                    CS.DOM.$body.offon(eventType, selectorOrCallBack);
            }
            else if (dontAutoOffOnDispose) //seconds overload
                CS.DOM.$body.offonwithoutautooff(eventType, selectorOrCallBack, callback);
            else
                CS.DOM.$body.offon(eventType, selectorOrCallBack, callback);
        }
        Events.$On = $On;
        /**This class is to handler register and raise of event. To be use when you make a class that's not bound to a control. */
        class Event {
            /**
             * This class is to handler register and raise of event. To be use when you make a class that's not bound to a control.
             * @param eventName
             * the event name will be see on logs if something go wrong. Put the public property name exposed to the consumer.
             * @param remoteRaiseEvent
             * the raiseDataChange will be created, just pass an object ex: let c = {}; after instanciation, you will be able to call c.raiseDataChange(...)
             */
            constructor(eventName, remoteRaiseEvent) {
                this.eventName = eventName;
                this.raiseEventCallbacks = new Array();
                remoteRaiseEvent.raiseEvent = (e, c, f) => { this.raiseEvent(e, c, f); };
            }
            Register(callback) { this.raiseEventCallbacks.push(callback); }
            raiseEvent(eventArgs, caller, forceThrowError = false) {
                if (this.raiseEventCallbacks && this.raiseEventCallbacks.length > 0)
                    for (var i = 0; i < this.raiseEventCallbacks.length; i++) {
                        try {
                            this.raiseEventCallbacks[i].call(caller, eventArgs);
                        }
                        catch (e) {
                            if (forceThrowError)
                                throw e;
                            else
                                console.error(`Error in the callback #${i} of ${this.eventName}`, this.raiseEventCallbacks[i].toString(), this.raiseEventCallbacks[i], e);
                        }
                    }
            }
        }
        Events.Event = Event;
        //export function On(event: CS.EventEnum, selector: any, callback?: (control: any, data?: any, e?: JQueryEventObject) => void, namespace?: string) {
        //    CS.Controls.EventsHandler.On(event, selector, callback);
        //}
    })(Events = CS.Events || (CS.Events = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-events.js.map
